import Swiper, { Navigation } from 'swiper'
import { Fancybox } from '@fancyapps/ui'
Swiper.use([Navigation])

class Gallery {
  constructor (el) {
    this.el = el
    this.sliderEl = this.el.querySelector('.js-gallery-slider')
    this.slider = null

    this.initDefaults()
  }

  initDefaults () {
    this.initSlider()
    this.initFancyBox()
  }

  initSlider () {
    this.slider = new Swiper(this.sliderEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        prevEl: '.gallery__btn_prev',
        nextEl: '.gallery__btn_next',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30
        }
      }
    })
  }

  initFancyBox () {
    Fancybox.bind("[data-fancybox]", {
      Image: {
        zoom: false,
      },
      Toolbar: {
        display: [
          "close",
        ]
      }
    });
  }

  openModal (e) {
    e.preventDefault()
    const url = e.currentTarget.getAttribute('href')
    this.modalImg.setAttribute('src', url)
    this.modal.classList.add('active')
  }

  closeModal (e) {
    e.preventDefault()
    this.modal.classList.remove('active')
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.js-gallery')

  if (items.length) {
    items.forEach(el => {
      new Gallery(el)
    })
  }
})